// Single source of truth for URLs. Reference these everywhere instead of string literals.
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',

  USERS: '/users',
  USER_DETAIL: (id = ':id') => `/users/${id}`,

  NEWS: '/news',
  NEWS_DETAIL: (id = ':id') => `/news/${id}`,

  SCRAPER: '/scraper',

  QUIZZES: '/quizzes',
  QUIZ_DETAIL: (id = ':id') => `/quizzes/${id}`,

  MAINS: '/mains',
  MAINS_DETAIL: (id = ':id') => `/mains/${id}`,

  MAINS_QUESTIONS: '/mains-questions',
  MAINS_QUESTION_NEW: '/mains-questions/new',
  MAINS_QUESTION_DETAIL: (id = ':id') => `/mains-questions/${id}`,

  CHATS: '/chats',
  AI_USAGE: '/ai-usage',

  CATEGORIES: '/categories',
  EXAMS: '/exams',
  ALERTS: '/alerts',
  DOWNLOADS: '/downloads',
  BANNERS: '/banners',

  PAYMENTS: '/payments',
  SUBSCRIPTIONS: '/subscriptions',
  RECURRING_SUBSCRIPTIONS: '/subscriptions/recurring',
  RENEWALS: '/renewals',
  WEBHOOK_LOGS: '/webhook-logs',
  COUPONS: '/coupons',

  SETTINGS: '/settings',

  FORBIDDEN: '/403',
  NOT_FOUND: '*',
};

export default ROUTES;
